<template>

    <section id="cloud-plan" class="cloud-plan" >
        <section id='sub-part' name='subscribe'>
            <location-duration-selector
                :storageLocList='storageLocList'
                :cloudProductLists='cloudProductLists'
                @changeSelect='handleLocationChange'
                @changeDuration='handleDurationChange'
                :durationList="durationList"
                :hideCountryDialog="isUpdatePlan"
                v-if="deviceGroupList?.length"
            />
        </section>

        <section class="plans-select" id="plans-select" :class="{ 'no-bottom-margin': noBottomMargin }">
            <div>
                <div class='legacy_tip_container' v-if='isLegacyPlanOwner'>
                    <div class='legacy_tip'>
                        <span class='icon-icon-hint-warning'></span>
                        <span class='tip_content' v-html="$t('homepage.legacy_tip', lang, { link: config.legacy_plan_support })"></span>
                    </div>
                </div>
                <RichText class="country-text" v-if="countryPromotionText" :html="countryPromotionText"/>
                <div v-if="showGlobalPromotionText">
                    <div class="global-promotion-text"
                        v-for="globalPromotion in globalPromotions"
                        :key="globalPromotion.textKey">
                        <i18n :path="globalPromotion.textKey" tag="span">
                            <button class="button_clear code" place="code" @click="handleCopyCode(globalPromotion.code)">
                                {{ globalPromotion.code }}
                            </button>
                        </i18n>
                        <ReoTip class="tip">
                            <template>
                                <p v-html="$t(globalPromotion.moreInfoKey)"></p>
                            </template>
                        </ReoTip>
                    </div>
                </div>
                <div
                    v-if="deviceGroupList.length>0"
                    class="plan-content"
                    :class='[{"tipAbove":!isLegacyPlanOwner}]'
                    :style="deviceGroupInfoStyle"
                    :key='currentDuration.key'
                >
                    <carousel
                        ref="planCarousel"
                        :mouseDrag="false"
                        :items="carouselItems"
                        :key='locationKey+currentDuration'
                        :margin="24"
                        v-if="deviceGroupList.length>1"
                        @ready="onCarouselReady"
                    >
                        <device-group-plans v-for="(deviceGroup, index) in deviceGroupList"
                            :key="index"
                            ref="deviceGroupPlans"
                            :deviceGroupInfo="deviceGroup"
                            :subscription="sub"
                            :activeItem="activeItem"
                            :listIndex="index"
                            :promotions="promotions"
                            @changeActive="changeActive"
                            :show-ai-info="showAiInfo"
                            :current-duration="currentDuration"
                            :cloudProductLists="cloudProductLists"
                            :checkIfPlanRenewable="checkPlanRenewable"
                            :isUpdatePlan="isUpdatePlan"
                            :has-free-subscription="hasFreeSubscription"
                            @goSubscription="selectDevices"
                        />
                    </carousel>
                    <template v-else>
                        <device-group-plans v-for="(deviceGroup, index) in deviceGroupList"
                            :key="index"
                            ref="deviceGroupPlans"
                            :deviceGroupInfo="deviceGroup"
                            :subscription="sub"
                            :activeItem="activeItem"
                            :listIndex="index"
                            :promotions="promotions"
                            @changeActive="changeActive"
                            :show-ai-info="showAiInfo"
                            :current-duration="currentDuration"
                            :cloudProductLists="cloudProductLists"
                            :checkIfPlanRenewable="checkPlanRenewable"
                            :isUpdatePlan="isUpdatePlan"
                            :has-free-subscription="hasFreeSubscription"
                            @goSubscription="selectDevices"
                            class="single-card"
                        />
                    </template>
                </div>

                <div class='bottom-wrapper' :class="{isMobile}" v-if="basicSerial.plans && isNewCustomer">
                    <section class='basic-plan-container'>
                        <div class='show-basic-plan-container'>
                            <a v-if='basicSerial.plans && isNewCustomer' class="ui-link showBasicBtn" @click='handleShowBasicPlan'>
                                <span class='text'>{{ $t('homepage.show_basic_plan') }}</span><span class="icon" v-if='!isExpand'>+</span><span class="icon" v-if='isExpand'>-</span>
                            </a>
                        </div>
                        <div class="basic-plan" v-if="basicSerial.plans && isNewCustomer && isExpand">
                            <basic-plan-card
                                :key='locationKey'
                                :planTitle="basicSerial.i18n.name"
                                :cloudProductLists="cloudProductLists"
                                type="new"
                                :loc="isUpdatePlan ? 'update' : 'subscribe'"
                                :locationKey='locationKey'
                                :modelKey="currentDuration.key"
                                :basicSerial="basicSerial"
                                :showSubscribe="isStorageAvailableCountry"
                                @subscribe="selectDevices"
                            />
                        </div>
                    </section>
                </div>
            </div>
        </section>
        <template v-if="subscribeArgs">
            <select-device-dialog
                v-model="showDevices"
                :subscribeArgs="subscribeArgs"
                :deviceData="deviceData"
                :subDeviceGroup="sub?.plan.series?.deviceGroup"
                :subId="sub?.id"
                :defaultSelectedUids="defaultSelectedUids"
                @select-device="$emit('subscribe', $event)"
                :confirmGaLabel="confirmGaLabel"
            />
        </template>
        <reo-dialog v-if="showFreeSubscriptionNotice" @cancel="showFreeSubscriptionNotice = false">
            <div class="dialog-content">
                {{ $t('errors.one_free_plan') }}
            </div>
        </reo-dialog>
        <email-verify-dialog v-model="showEmailVerifyDialog" @verified="selectDevices" :from="from"/>
    </section>

</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import CloudLogo from 'IMAGE/homepage/cloud-logo.png';
import IntroImg from 'IMAGE/homepage/homepage-introducing.png';
import { config } from 'CONFIG';
import { isInVisibleArea, valueWithFallbacks, groupBy } from '@/common/js/utils';
import { listToString } from '@/api/s3Config';
import { unfoldError } from '@/common/js/notice';
import { getCloudProductLists } from '@/api/reolink/cart';
import DeviceGroupPlans from './components/DeviceGroupPlans.vue';
import paymentMethods from '@/config/paymentMethods';
import Carousel from '@/basic/Carousel.vue';
import LocationDurationSelector from './components/LoactionDurationSelector.vue';
import nprogress from 'nprogress';
import { checkFreePlanTrack, checkNewCustomer, getTotalSubs, ownLegacyPlan } from '@/api/dashboard';
import { ensureGdprCookiesByCountry } from '@/common/js/gdprCookie';
import BasicPlanCard from './components/BasicPlanCard.vue';
import { getPromotionItems } from '@/api/order';
import { fetchAllPages } from '@/utils/request';
import { Async } from '@reolink-web/utils';
import {
    currStage,
    ESeriesCategory,
    IEsim,
    IOrder,
    IPlanSeries,
    IProductData,
    IPromotionItem,
    ISubscription,
    paymentStatus
} from '@reolink-cloud/interface';
import { animatedPlanFilter, getCountryPromotionText, getDeviceGroupWithPlans, getShowAiInfo, isSupportRichNotification } from '@/utils/business';
import { IDeviceGroupWithPlans, IDuration, IPlanRenewableInfo, IProductPageArgs, ISubscribeArgs, ISubscriptionWithPlanInfo, ITotalDeviceWithSubInfo } from './lib/types';
import { getPlansByDuration } from './lib/utils';
import SelectDeviceDialog from './components/SelectDeviceDialog.vue';
import { getDeviceTotal } from '@/api/cloud';
import { getIccidByUid, getSubscriptions } from '@/api/subscriptions';
import { getOrders, getPlanById } from '@/api/cart';
import dayjs from 'dayjs';
import * as _ from '@reolink-web/utils';
import { mapGetters } from 'vuex';
import EmailVerifyDialog from '../EmailVerifyDialog.vue';
import ReoDialog from '@/basic/Dialog.vue';
import { subscribeConfig } from './lib/config';
import ReoTip from '@/basic/Tip.vue';
import { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/message.css';
import user from '@/api/user';
import reolinkGa from '@/common/js/gtagPageview';

export default Vue.extend({
    components: {

        DeviceGroupPlans,
        Carousel,
        LocationDurationSelector,
        BasicPlanCard,
        SelectDeviceDialog,
        EmailVerifyDialog,
        ReoDialog,
        ReoTip,

    },
    props: {
        productsArgs: Object as PropType<IProductPageArgs>,
        sub: Object as PropType<ISubscriptionWithPlanInfo | null>,
        confirmGaLabel: String,
        from: String,
        filterRichNotification: {
            type: Boolean,
            default: false
        },
        skipDeviceSelection: {
            type: Boolean,
            default: false
        },
        filterByDeviceModelId: {
            type: Number,
            default: 0
        },
        noBottomMargin: {
            type: Boolean,
            default: false
        },
        defaultSelectedUids: {
            type: Array as PropType<string[]>,
            default: (): string[] => []
        },
        filterModelGroups: Object as PropType<Set<string> | undefined>,
    },

    data () {

        return {

            paymentMethods,
            config,
            discount: 0,
            activeItem: 100,
            carouselItems: 3,
            scrollHandleEnable: true,
            mobileSubBtnShow: false,
            basicSerial: {} as Record<string, any>,
            isShowTitle: true,
            cloudProductLists: {} as Record<string, any>,
            storageLocList: {} as Record<string, any>,
            locationKey: '',
            currentDuration: {} as IDuration,
            userSelectLoc: {} as Record<string, any>,
            supportedDeviceList: [] as any[],
            supportedCountryList: [] as any[],
            planNoticeText: '',
            count: 0,
            readyEmitted: false,
            showAvailableDevices: false,
            supportedTrafficDeviceList: [] as any[],
            isNewCustomer: true,
            freePlanTrack: false,
            CloudLogo,
            IntroImg,
            legacySubs: [] as any[],
            isExpand: false,
            promotions: [] as IPromotionItem[],
            ipCountry: config.fallbackCountry,
            showAiInfo: false,
            showDevices: false,
            subscribeArgs: null as null | ISubscribeArgs,
            deviceData: [] as ITotalDeviceWithSubInfo[],
            subs: [] as ISubscription[],
            orders: [] as IOrder[],
            heightObserver: null as ResizeObserver | null,
            elementHeights: {
                deviceGroupInfo: 0,
                planNoticeBox: 0
            },
            showEmailVerifyDialog: false,
            showFreeSubscriptionNotice: false,
            globalPromotions: subscribeConfig.globalPromotionInfo,
            esimProfile:null as IEsim[]|null,
            allDeviceGroupList: [] as IDeviceGroupWithPlans[],
        };

    },
    async created() {

        this.esimProfile = await getIccidByUid();

    },
    mounted () {

        window.addEventListener( 'scroll', this.scrollHandle );
        this.$nextTick(() => {

            this.initHeightObserver();

        });

    },

    methods: {
        handleShowBasicPlan(): void {

            reolinkGa.sendSimpleEvent( 'Cloud Storage Service-find more' );
            this.isExpand = !this.isExpand;

        },
        carouselInit () {

            if ( this.isMobile ) {

                this.carouselItems = 1;

            }
            else if ( this.deviceGroupList.length < 3 ) {

                this.carouselItems = this.deviceGroupList.length;

            } else {

                this.carouselItems = 2;

            }

            this.$nextTick(() => {

                if ( this.deviceGroupList.length > 1 ) {

                    ( this.$refs.planCarousel as any ).init();

                }

            });

        },
        onCarouselReady () {

            if ( !this.readyEmitted ) {

                requestAnimationFrame(() => {

                    if ( !this.readyEmitted ) {

                        this.readyEmitted = true;
                        this.$emit( 'ready' );

                    }

                });

            }

        },
        async getPlans () {

            try {

                let data: Record<string, any> = {};
                let lang = this.$i18n.locale;
                Async.invokeAsync( async () => {

                    try {

                        this.promotions = await fetchAllPages( getPromotionItems, {
                            page: 1,
                            limit: 100,
                            lang: this.lang,
                            country: this.country,
                            firstChargeData: {
                                user: {
                                    planCategories: [ ESeriesCategory.CLOUD_STORAGE_PLAN ]
                                }
                            }
                        });

                    } catch ( e ) {

                        console.error( 'get promotion error', e );

                    }

                });

                const includeNotificationPlan = this.$route.query.includeNotificationPlan === 'true';
                data = await getCloudProductLists( lang, this.country, this.productsArgs, includeNotificationPlan );
                ensureGdprCookiesByCountry( this.country, this.$i18n.locale );
                if ( this.isLogin ) {

                    let { subs, activeSubs } = await getTotalSubs();
                    this.isNewCustomer = checkNewCustomer( subs );
                    this.freePlanTrack = checkFreePlanTrack( subs );
                    this.legacySubs = ownLegacyPlan( activeSubs );

                }

                if ( this.client !== 'reolink' ) {

                    this.isNewCustomer = false;

                }
                this.cloudProductLists = data.cloudProductLists;
                this.ipCountry = data.country;
                this.storageLocList = data.storageLocList;

                this.supportedTrafficDeviceList = data.supportedTrafficDeviceList;
                this.count++;
                nprogress.done();

            } catch ( err ) {

                console.error( err );
                unfoldError( 'errors.server_error' );
                nprogress.done();

            }

        },

        changeActive ( index ) {

            this.activeItem = index;

        },

        selectDevices ( args?: ISubscribeArgs ) {

            if ( args ) this.subscribeArgs = args;

            if ( !this.isLogin ) {

                // 将订阅参数存储到 localStorage，登录后恢复
                if ( this.subscribeArgs ) {

                    localStorage.setItem( 'pendingSubscribeArgs', JSON.stringify( this.subscribeArgs ));

                }
                user.goToAccountCenter( true ).catch( console.error );
                return;

            }

            if ( !this.verified ) {

                this.showEmailVerifyDialog = true;
                return;

            }
            const isFreePlan = parseFloat( this.subscribeArgs?.plan.pricing.salePrice ?? '1' ) === 0;
            if (( this.hasFreeSubscription || this.freePlanTrack ) && isFreePlan ) {

                this.showFreeSubscriptionNotice = true;
                return;

            }

            let isHasAvailableModel = false;

            for ( const element of this.filterDevice ) {

                // 如果存在可绑定的设备，则isHasAvailableModel为true
                if ( this.subscribeArgs?.availableModels.includes( element.modelTitle )) {

                    isHasAvailableModel = true;
                    break;

                }

            }

            // 如果当前没有可以绑定的设备，则直接跳转checkout页面
            if ( !isHasAvailableModel || this.skipDeviceSelection ) {

                this.$emit( 'subscribe', this.subscribeArgs );
                return;

            }
            this.showDevices = true;

        },

        checkPendingSubscription (): void {

            // 检查是否有待处理的订阅参数
            const storedArgs = localStorage.getItem( 'pendingSubscribeArgs' );
            if ( storedArgs && this.isLogin ) {

                try {

                    const parsedArgs = JSON.parse( storedArgs ) as ISubscribeArgs;
                    localStorage.removeItem( 'pendingSubscribeArgs' );

                    this.selectDevices( parsedArgs );

                } catch ( error ) {

                    console.error( '恢复订阅参数失败:', error );
                    localStorage.removeItem( 'pendingSubscribeArgs' );

                }

            }

        },

        scrollHandle ( ) {

            if ( !this.scrollHandleEnable ) {

                return false;

            }
            this.scrollHandleEnable = false;
            setTimeout(() => {

                if ( $( 'body' ).eq( 0 )[ 0 ].offsetWidth < 1200 ) {

                    this.calcPlanIsInWindow();

                }
                this.scrollHandleEnable = true;

            }, 100 );

        },

        calcPlanIsInWindow () {

            let visible = isInVisibleArea( '#plans-select' );
            this.mobileSubBtnShow = visible;

        },

        jumpToPlan () {

            document.querySelector( '#sub-part' )!.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });

        },
        handleDurationChange ( val: IDuration ) {

            this.currentDuration = val;
            this.$nextTick(() => {

                this.initHeightObserver();

            });

        },
        handleLocationChange ( val ) {

            // 请求不同的套餐
            this.locationKey = val.locationKey;
            this.supportedDeviceList = val.supportedDeviceList;
            this.supportedCountryList = val.supportedCountryList;
            if ( val.list.length > 0 ) {

                if ( this.isNewCustomer && !this.filterRichNotification ) {

                    this.basicSerial = val.basicSerial ?? {};

                } else {

                    for ( const [key, deviceGroupInfo] of Object.entries<IDeviceGroupWithPlans>( this.storageLocList[val.locationKey].deviceGroupsList ?? {})) {

                        if ( deviceGroupInfo.basicSerial ) {

                            const basicSerial = {
                                ...deviceGroupInfo.basicSerial,
                                products: deviceGroupInfo.basicSerial.plans
                            };

                            ( this.storageLocList[this.locationKey].deviceGroupsList[key] as IDeviceGroupWithPlans ).planList = [
                                ...( this.storageLocList[this.locationKey].deviceGroupsList[key] as IDeviceGroupWithPlans ).planList,
                                basicSerial
                            ];

                        }

                    }

                }

            } else {

                this.basicSerial = {};

            }
            this.planNoticeText = typeof this.cloudProductLists.storageRegions[this.locationKey].i18n.note !== 'undefined' ? this.cloudProductLists.storageRegions[this.locationKey].i18n.note : '';
            this.$nextTick(() => {

                this.initHeightObserver();

            });

        },
        goAnchor ( id ) {

            document.querySelector( `#${id}` )!.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });

        },
        async getIfShowAiInfo() {

            this.showAiInfo = await getShowAiInfo( this.country );

        },
        async initDeviceAndSubs() {

            if ( !this.isLogin ) return;

            const [deviceDataRaw, { items: subs }] = await Promise.all( [
                getDeviceTotal(),
                getSubscriptions()
            ] );
            const deviceData = deviceDataRaw as ITotalDeviceWithSubInfo[];
            for ( let device of deviceData ) {

                for ( let sub of subs ) {

                    if ( device.subscription === sub.id ) {

                        device.subName = sub.title;
                        if ( typeof this.cloudProductLists.plans[sub.plan] === 'undefined' ) {

                            let planDetails = await getPlanById( sub.plan, this.lang );
                            device.planTitle = planDetails.series.i18n.name;
                            this.cloudProductLists.plans[`${sub.plan}`] = planDetails.plan;
                            this.cloudProductLists.plans[`${sub.plan}`].title = planDetails.series.i18n.name;
                            this.cloudProductLists.planSeries[`${planDetails.plan.seriesKey}`] = planDetails.series;

                        } else {

                            device.planTitle = this.cloudProductLists.plans[sub.plan].title;

                        }

                    }

                }
                if ( typeof device.modelTitle === 'undefined' ) {

                    Object.keys( this.cloudProductLists.deviceModels ).map( key => {

                        if ( this.cloudProductLists.deviceModels[key].title === device.model ) {

                            device.modelTitle = this.cloudProductLists.deviceModels[key].title;

                        }

                    });

                }

            }
            this.deviceData = deviceData;
            this.subs = subs;

        },
        checkPlanRenewable( planId: string ): IPlanRenewableInfo {

            return {
                isRenewable: this.subs.some( sub => sub.plan === planId && sub.status === 'active' ),
                autoRenewEnabled: this.subs.some( sub => sub.plan === planId && sub.autoRenewal )
            };

        },
        async getOrders() {

            if ( !this.isLogin ) return;

            const orders = await getOrders( 1, 100, dayjs().valueOf(), dayjs().subtract( 1, 'day' ).valueOf());
            this.orders = orders.items;

        },

        /**
         * 通用方法：收集指定元素
         */
        collectElements( methodName: string ): HTMLElement[] {

            const refs = this.$refs.deviceGroupPlans as Vue[] | Vue | undefined;
            if ( !refs ) {

                return [];

            }
            const components = Array.isArray( refs ) ? refs : [refs];
            return components.map(( comp: any ) => comp?.[methodName]?.()).filter( Boolean );

        },

        /**
         * 刷新所有元素的高度
         */
        refreshElementHeights(): void {

            // 定义需要监听的元素配置
            const elementConfigs = [
                { key: 'deviceGroupInfo', methodName: 'getDeviceGroupInfoEl' },
                { key: 'planNoticeBox', methodName: 'getPlanNoticeBoxEl' }
            ];

            for ( const { key, methodName } of elementConfigs ) {

                const elements = this.collectElements( methodName );
                if ( !elements.length ) {

                    this.elementHeights[key] = 0;
                    continue;

                }

                const maxHeight = Math.max( ...elements.map( element => {

                    return Math.ceil( element.getBoundingClientRect().height );

                }));
                this.elementHeights[key] = maxHeight;

            }

        },

        /**
         * 初始化高度观察器（单个 ResizeObserver 监听所有元素）
         */
        initHeightObserver(): void {

            // 清理旧的观察器
            if ( this.heightObserver ) {

                this.heightObserver.disconnect();

            }

            // 收集所有需要监听的元素
            const allElements = [
                ...this.collectElements( 'getDeviceGroupInfoEl' ),
                ...this.collectElements( 'getPlanNoticeBoxEl' )
            ];

            if ( !allElements.length ) {

                this.heightObserver = null;
                this.elementHeights.deviceGroupInfo = 0;
                this.elementHeights.planNoticeBox = 0;
                return;

            }

            // 创建单个观察器监听所有元素
            this.heightObserver = new ResizeObserver(() => {

                this.refreshElementHeights();

            });

            // 观察所有元素
            for ( const element of allElements ) {

                this.heightObserver.observe( element );

            }

            // 初始化高度
            this.refreshElementHeights();

        },
        async handleCopyCode( code: string ): Promise<void> {

            await navigator.clipboard.writeText( code );
            Message.success({
                message: this.$t( 'copied' ).toString(),
                offset: 90
            });

        },
        getDeviceGroupPlans(): IDeviceGroupWithPlans[] {

            let rawDeviceGroups = getDeviceGroupWithPlans( this.cloudProductLists as IProductData['cloudProductLists'], { country: this.country, category: ESeriesCategory.CLOUD_STORAGE_PLAN, legacyTag: this.sub?.legacyTag, keepBasic: !this.isNewCustomer });
            if ( rawDeviceGroups.length === 0 ) {

                rawDeviceGroups = getDeviceGroupWithPlans( this.cloudProductLists as IProductData['cloudProductLists'], { country: config.fallbackCountry, category: ESeriesCategory.CLOUD_STORAGE_PLAN });

            }

            for ( const deviceGroup of rawDeviceGroups ) {

                for ( const series of deviceGroup.planList ) {

                    series.products = series.products.filter( plan => {

                        /**
                         * 只允许订阅一次的套餐有在支付中的订单就不显示
                         */
                        for ( const order of this.orders ) {

                            if ( order.status.currStage === currStage.PAYMENT &&
                                order.status.paymentStatus === paymentStatus.CREATED &&
                                order.items[0].productType === 'storage_plan' &&
                                order.items[0].context.action !== 'renew'
                            )
                                if ( order.items[0].productId === plan.id && plan.limitations.userMaxSubscribeTimes === 1 ) {

                                    return false;

                                }

                        }

                        if ( plan.status === 'renew_only' ) {

                            return false;

                        }

                        if ( this.isUpdatePlan ) {

                            /**
                             * 切换套餐页面不显示不可以切换的套餐
                             */
                            if ( this.sub?.plan.id !== plan.id ) {

                                return plan.limitations.switchFromOther;

                            } else if ( this.sub && this.sub.plan.id === plan.id ) {

                                // 当前订阅套餐不显示
                                return false;

                            }

                        }
                        return true;

                    }).filter( animatedPlanFilter )
                        .filter( plan => !this.filterRichNotification || isSupportRichNotification( plan ));

                }

            }

            const { filterByDeviceModelId, filterModelGroups } = this;
            return rawDeviceGroups.filter( group =>
                ( !filterByDeviceModelId || group.modelIds?.includes( filterByDeviceModelId )) &&
                ( !filterModelGroups?.size || filterModelGroups.has( group.key ))
            );

        }

    },

    computed: {
        ...mapGetters( ['isLogin', 'isStorageAvailableCountry'] as const ),
        currentLang () {

            return this.$store.getters.lang;

        },

        loginDashboardUrl () {

            return config.accountCenterLoginUrl + '?redirect=' + window.location.origin + '/user/cloud-library/';

        },

        signupUrl () {

            return config.accountCenterLoginUrl + '?redirect=' + window.location.origin + '/user/cloud-library/#signup';

        },

        userId(): boolean {

            return this.$store.getters.userId;

        },

        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },

        lang(): string {

            return this.$store.getters.lang;

        },

        device (): string {

            let deviceList = this.supportedDeviceList;
            if ( !deviceList?.length ) {

                return '';

            }
            return listToString( deviceList.map( item => item.product ));

        },
        filterDevice(): ITotalDeviceWithSubInfo[] {

            return this.deviceData?.filter( item => {

                const isLocked = this.esimProfile?.find( esim => esim.uid === item.uid );

                return !isLocked && item.boundStatus === 'bound';

            }) ?? [];

        },
        countrySupported (): string {

            let countrySupported = this.supportedCountryList;
            if ( !countrySupported?.length ) return '';
            let locale = this.lang;
            let texts = countrySupported.map( item => item[ locale ] );
            if ( !texts?.length ) {

                return '';

            }
            return listToString( texts );

        },
        userStatus (): string {

            return this.$store.state.user.status;

        },
        client (): string {

            return this.config.oem;

        },
        isLegacyPlanOwner (): boolean {

            return Boolean( this.sub?.legacyTag );

        },
        country(): string {

            return valueWithFallbacks( this.$store.getters.country, this.ipCountry );

        },
        deviceGroupList(): IDeviceGroupWithPlans[] {

            return this.allDeviceGroupList.filter( item  => getPlansByDuration( item.planList, this.currentDuration ).length > 0 ).sort(( a, b ) => {

                return ( b?.sort ?? 0 ) - ( a?.sort ?? 0 );

            });

        },
        durationList(): IDuration[] {

            let list: IDuration[] = [];

            for ( const planItem of this.allDeviceGroupList.map( item => item.planList.map( series => series.products )).flat( 2 )) {

                const amount = planItem.duration.amount;
                const unit = planItem.duration.unit;
                const key = `${amount}-${unit}`;
                if ( !list.some( item => item.key === key ) && !planItem.seriesKey.includes( 'basic' )) {

                    list.push({
                        key,
                        title: this.$tc( `cycle.${unit}`, amount === 1 ? 1 : 0, { count: amount }),
                        id: key,
                        amount,
                        unit
                    });

                }

            }

            const unitToOrder = {
                year: 0,
                month: 3,
                week:2,
                day: 1
            };
            list = list.sort(( a, b ) => {

                if ( a.unit === b.unit ) {

                    return a.amount - b.amount;

                } else {

                    return unitToOrder[a.unit] - unitToOrder[b.unit];

                }

            });

            return list;

        },
        isUpdatePlan(): boolean {

            return this.productsArgs?.page === 'update-plan';

        },
        hasFreeSubscription(): boolean {

            if ( !this.subs.length ) return false;
            return this.subs.some( sub => {

                const plan = this.cloudProductLists.plans[sub.plan];
                const series: IPlanSeries = this.cloudProductLists.planSeries[plan?.seriesKey];
                if ( plan && series ) {

                    return series.category === ESeriesCategory.CLOUD_STORAGE_PLAN && parseFloat( plan.pricing.salePrice ) === 0 && sub.status === 'active';

                }
                return false;

            });

        },
        countryPromotionText(): string | undefined {

            return getCountryPromotionText( this.promotions,
                getPlansByDuration( this.deviceGroupList.reduce(
                    ( acc, group ) => acc.concat(
                        ...group.planList
                    ),
                    []
                ), this.currentDuration )
            );

        },

        showGlobalPromotionText(): boolean {

            return !this.currentDuration?.key?.includes( 'month' ) && this.$store.getters.country !== 'US';

        },

        deviceGroupInfoStyle(): Record<string, string> {

            const { deviceGroupInfo, planNoticeBox } = this.elementHeights;

            if ( !deviceGroupInfo && !planNoticeBox ) {

                return {};

            }

            const style: Record<string, string> = {};

            if ( deviceGroupInfo ) {

                style['--device-group-info-height'] = `${Math.ceil( deviceGroupInfo )}px`;

            }

            if ( planNoticeBox ) {

                style['--plan-notice-box-height'] = `${Math.ceil( planNoticeBox )}px`;

            }

            return style;

        },
        verified (): boolean {

            return this.$store.state.user.user.email.status === 'verified';

        },

    },

    watch: {

        userStatus: {

            async handler ( newVal ): Promise<void> {

                if (( newVal === 'logined' || newVal === 'notLogined' ) && this.count < 1 ) {

                    await Promise.all( [
                        this.getPlans(),
                        this.getIfShowAiInfo(),
                        this.getOrders()
                    ] );
                    await this.initDeviceAndSubs();
                    this.allDeviceGroupList = this.getDeviceGroupPlans();
                    this.currentDuration = this.durationList[0];

                    this.checkPendingSubscription();
                    this.$nextTick(() => {

                        if ( this.deviceGroupList.length < 1 && !this.readyEmitted ) {

                            requestAnimationFrame(() => {

                                if ( !this.readyEmitted ) {

                                    this.readyEmitted = true;
                                    this.$emit( 'ready' );

                                }

                            });

                        }

                    });
                    if ( window.location.href.includes( 'rich-notification' )) {

                        this.$nextTick(() => {

                            this.goAnchor( 'rich-notification' );

                        });

                    }

                }

            },

            immediate: true,
        },
        isMobile () {

            this.$nextTick(() => {

                this.carouselInit();
                this.initHeightObserver();

            });

            if ( this.currentDuration ) {

                this.handleDurationChange( this.currentDuration );

            }

        },
        deviceGroupList () {

            this.$nextTick(() => {

                this.carouselInit();
                this.initHeightObserver();
                if ( this.deviceGroupList.length <= 1 ) {

                    this.$nextTick(() => {

                        requestAnimationFrame(() => {

                            if ( !this.readyEmitted ) {

                                this.readyEmitted = true;
                                this.$emit( 'ready' );

                            }

                        });

                    });

                }

            });

        },
        filterByDeviceModelId: {

            handler() {

                if ( this.count >= 1 ) {

                    this.allDeviceGroupList = this.getDeviceGroupPlans();

                }

            }

        },
        filterModelGroups: {

            handler() {

                if ( this.count >= 1 ) {

                    this.allDeviceGroupList = this.getDeviceGroupPlans();

                }

            }

        }

    },

    destroyed () {

        window.removeEventListener( 'scroll', this.scrollHandle );

        // 清理观察器
        if ( this.heightObserver ) {

            this.heightObserver.disconnect();
            this.heightObserver = null;

        }

    }

});

</script>

<style rel="stylesheet/css" lang="less" scoped>

</style>

<style scoped rel="stylesheet/css" lang="less">

:target:before,
.hash-target{
    display: block;
    height: 1.5rem;
    margin: -1.5rem 0 0;
    cursor: auto;
}

.unique-plan {
    background-color: #F7F8F9;
    padding: 0 .6rem .4rem;
    max-width: 12rem;
    margin:0 auto;
    box-sizing: border-box;
    @media @pc{
        padding-top: .3rem;
    }
}

.basic-plan{
    max-width: 12rem;
    margin:0 auto;
    box-sizing: border-box;
    padding-top: 16px;
    @media @mobile{
        padding-top: 20px;
    }
}

.plans-select{
    margin: 0 auto;
    max-width: 1000px;
    box-sizing: border-box;
    margin-bottom: 80px;
    .mobile({
        margin: 0;
    });

    &.no-bottom-margin {
        margin-bottom: 0;
    }

    .titleBox{
        .title{
            font-weight: 500;
            font-size: 0.2rem;
            line-height: 1.4;
            color:#333333;
            @media @mobile{
                font-size: .28rem;
                text-align: left;
                padding: 0 20px .16rem;
            }
        }
        .notice-for-free{
            padding-top: 0.1rem;
            color:#333333;
            font-size: .16rem;
            line-height: 1.4;
            .des{
                margin-top: 0.08rem;
                display: block;
            }
            @media @mobile{
                padding: 0 20px;
                // margin-bottom:.32rem;
                text-align: left;
                margin: 0;
            }
        }
    }
    .legacy_tip_container{
        font-size: 18px;
        @media @pc{
            margin-bottom:24px;
        }
        @media @mobile{
            font-size: 14px;
            margin-bottom:20px;
        }
        .legacy_tip{
            padding: 14px 20px;
            text-align: left;
            background: @b_1;
            border-radius: 16px;
            display: flex;
            .icon-icon-hint-warning{
                color:#C15400;
                @media @pc{
                    font-size: .3rem;
                }
            }
            .tip_content{
                color:#333;
                font-weight: 500;
                margin-left:.2rem;
                /deep/ .support-link{
                    font-weight: 500;
                    color: @b_6;
                    cursor: pointer;
                    text-decoration: underline;
                    text-decoration-thickness:1px;
                }
                /deep/ a{
                    font-weight: 500;
                }
            }

        }

    }
    .country-text{
        font-size: 14px;
        color: #FF894A;
        font-weight: 600;
        text-align: left;
        @media @pc{
            margin-bottom:24px;
        }
        @media @mobile{
            margin-bottom:20px;
        }

    }
    .global-promotion-text{
        .country-text();
        font-weight: 500;
        .code{
            font-size: 14px;
            line-height: 17px;
            font-weight: 500;
            color: @b_6;
            text-decoration: underline;
        }
        .tip{
            margin-left: 4px;
            padding-bottom: 5px;
            /deep/ .tip-icon{
                font-size: 13px;
                line-height: 13px;
            }
        }
    }
}

.bottom-wrapper{
    display: flex;
    flex-direction: column;
    padding-top: 24px;
    .mobile({
        padding-top: 20px;
    });

    .plan-bottom{
        padding-top: 16px;
        margin-top: 16px;
        border-top: 1px solid @line;

        @media @mobile{
            text-align: left;
            padding-top: 12px;
            margin-top: 20px;
        }
    }
}

.show-basic-plan-container{
    width: 100%;
    text-align: left;
    margin-top: 0;
    line-break: 1.2;
    @media @mobile{
        width: unset;
    }

    .showBasicBtn{
        font-weight: 500;
        font-size: .16rem;
        @media @mobile{
            font-size:16px;
        }
        color:#333;
        cursor: pointer;
        span:last-child{
            margin-left: 8px;
        }
    }

}

#sub-part{
    margin:0 auto;
    @media @pc{
        max-width: 1000px;
    }
    .title{
        color: #333;
        font-size: 42px;
        line-height: 1.2;
        padding-top: 80px;
        margin-bottom: 24px;
        text-align: center;
        .mobile({
            font-size: 28px;
            padding-top: 32px;
            padding-bottom: 12px;
        })
    }
}

.buttons{
    display: flex;
    justify-content: center;
}

.dialog-content{
    font-size: 16px;
}

</style>
